import { parsePricingInstanceKey } from "./pricingSessionUtils";

// Keep successful local moves until the index catches up. The assignee count
// lets a later move (including a move back to a previous owner) take precedence.
export function rememberJobReassignment(tree, orgId, reassignment) {
	const source = parsePricingInstanceKey(reassignment.srcInstanceUrl);
	const target = parsePricingInstanceKey(reassignment.dstInstanceUrl);
	if (!orgId || !source || !target
		|| source.instanceId !== target.instanceId || source.activityId !== target.activityId) {
		throw new Error("The reassigned job identity could not be verified.");
	}
	const path = ["appState", "jobReassignmentTargets", orgId, target.instanceId];
	const previous = tree.get(path);
	const profilePicture = reassignment.profilePicture;
	tree.set(path, {
		sourceUrls: Array.from(new Set([...(previous?.sourceUrls || []), reassignment.srcInstanceUrl])),
		assigneeCount: reassignment.assigneeCount,
		hit: {
			id: target.activityId,
			instanceId: target.instanceId,
			url: reassignment.dstInstanceUrl,
			identityId: target.identityId,
			displayName: reassignment.displayName,
			profilePicture: profilePicture && profilePicture !== "none" ? profilePicture : "",
			...(reassignment.customerIdentitySnapshot ? {
				company: reassignment.customerIdentitySnapshot.company,
				customerGuid: reassignment.customerIdentitySnapshot.customerGuid,
				customerCode: reassignment.customerIdentitySnapshot.customerCode
			} : {})
		}
	});
}

export function resolveJobReassignmentHit(tree, orgId, hit, indexedHit) {
	const pending = tree.get(["appState", "jobReassignmentTargets", orgId, hit.instanceId]);
	const current = { ...hit, ...indexedHit };
	if (!pending) {
		return current;
	}
	const indexedAssigneeCount = indexedHit && indexedHit.sourceAssigneeLength;
	if (Number.isInteger(indexedAssigneeCount) && indexedAssigneeCount >= pending.assigneeCount) {
		return current;
	}
	if (indexedHit && indexedHit.url !== pending.hit.url && !pending.sourceUrls.includes(indexedHit.url)) {
		// Another client has already moved the job beyond our local move.
		return current;
	}
	return { ...current, ...pending.hit };
}

export function createJobReassignedError() {
	const error = new Error("This job was reassigned. Your changes have not been applied to the current job. Keep this window open to review your edits, then reopen View Job from the Job Board and reapply them.");
	error.code = "JOB_REASSIGNED";
	return error;
}
